import createAxiosClient, { config } from "../utils/api-utils";
class FavouriteApi {
  constructor() {
    this.client = createAxiosClient();
  }
  async addFavourite(data) {
    const reqData = {
      profileId: data,
    };
    return await this.client.post("/favourites", reqData, config());
  }

  async listFavourite() {
    return await this.client.get("/favourites", config());
  }

  async removeFavourite(profileId) {
    return await this.client.delete(`/favourites/${profileId}`, config());
  }
}
export default FavouriteApi = new FavouriteApi();
